import React, { memo } from 'react';
import { Modal } from "react-bootstrap";

const BidAlertTextModal = ({showAlert, onClose, alertText}) => {
  return (
    <Modal show={showAlert} onHide={onClose}>
      <Modal.Header closeButton className="license-title" tabIndex="0">
        <Modal.Title className="text-white roboreg" tabIndex="0">Place Bid</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="p-4 text-center roboreg" tabIndex="0">{alertText}</p>
        <div className="d-flex justify-content-center" tabIndex="0">
          <button className="no-btn" onClick={() => onClose()}>
            Ok
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default memo(BidAlertTextModal);